export enum PageName {
    ChatPage = "ChatPage",
    FriendPage = "FriendPage",
    FindPage = "FindPage",
    SettingsPage = "SettingsPage"
}